const Navigation = () => {
    return (
        <nav className="nav-container">
            <a href="#home" className="nav-link">home</a>
            <a href="#experience" className="nav-link">experience</a>
            <a href="#projects" className="nav-link">projects</a>
            <a href="https://www.linkedin.com/in/mauricio-mr/" target="_blank" rel="noreferrer" className="nav-link">linkedin</a>
            <a href="https://github.com/Mauricio0129" target="_blank" rel="noreferrer" className="nav-link">github</a>
        </nav>
    );
};

export default Navigation;
